import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root',
})
export class AppPreferencesService {
  public async getValue(key: string): Promise<string | null> {
    const result = await Preferences.get({ key });
    return result.value ?? null;
  }

  public async setValue(key: string, value: string): Promise<void> {
    return Preferences.set({ key, value });
  }

  public async removeValue(key: string): Promise<void> {
    return Preferences.remove({ key });
  }

  public async clear(): Promise<void> {
    return Preferences.clear();
  }
}
